module.exports = __webpack_public_path__ + "static/media/8.9a8078e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/8.jpg
// module id = 599
// module chunks = 0